import React from 'react';

// Props: steps (number), currentStep (number, 0-indexed)
const Stepper = ({ steps, currentStep }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '12px 0',
    gap: 4,
    position: 'relative',
  }}>
    {Array.from({ length: steps }).map((_, idx) => (
      <div
        key={idx}
        style={{
          flex: 1,
          height: 1,
          background: idx <= currentStep ? '#E77A45' : '#D5D1C9',
          position: 'relative',
          transition: 'background 0.4s',
        }}
      >
      </div>
    ))}
  </div>
);

export default Stepper;
